/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Dictionary_unknown_ } from './Dictionary_unknown_';
/**
 * Represents a product in the catalog system
 */
export type CatalogProduct = {
    /**
     * Unique identifier for the product
     */
    id: number;
    /**
     * Tenant identifier the product belongs to
     */
    tenantId: string;
    /**
     * Optional reference to the analysis configuration
     */
    analysisConfigId?: number | null;
    /**
     * Product name - required
     */
    name: string;
    /**
     * Product description
     */
    description?: string | null;
    /**
     * Optional canonical price in the provided currency
     */
    price?: string | null;
    /**
     * Currency code for the price (defaults to CLP if omitted)
     */
    currency?: CatalogProduct.currency | null;
    /**
     * External URL referencing the product
     */
    sourceUrl?: string | null;
    /**
     * External source identifier for the product
     */
    sourceId?: string | null;
    /**
     * Timestamp of when the product was created
     */
    createdAt: string;
    /**
     * Timestamp of when the product was last updated
     */
    updatedAt: string;
    /**
     * Optional custom fields for the product
     */
    customFields?: Dictionary_unknown_;
};
export namespace CatalogProduct {
    /**
     * Currency code for the price (defaults to CLP if omitted)
     */
    export enum currency {
        CLP = 'CLP',
        UF = 'UF',
    }
}

